'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button3 = require('./Button.scss');

var _Button4 = _interopRequireDefault(_Button3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Button, _Component);

    function Button() {
        (0, _classCallCheck3.default)(this, Button);
        return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
    }

    (0, _createClass3.default)(Button, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'disabled', 'primary', 'secondary', 'small', 'tertiary']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                disabled = _props.disabled,
                primary = _props.primary,
                onClick = _props.onClick,
                onMouseOut = _props.onMouseOut,
                onMouseOver = _props.onMouseOver,
                secondary = _props.secondary,
                tertiary = _props.tertiary,
                small = _props.small;


            var classes = (0, _classnames2.default)(_Button4.default.button, (_classNames = {}, (0, _defineProperty3.default)(_classNames, _Button4.default.secondary, secondary), (0, _defineProperty3.default)(_classNames, _Button4.default.primary, primary), (0, _defineProperty3.default)(_classNames, _Button4.default.small, small), (0, _defineProperty3.default)(_classNames, _Button4.default.tertiary, tertiary), _classNames), className);

            var buttonProps = {
                className: classes
            };
            if (disabled) {
                buttonProps.disabled = disabled;
            }
            if (onClick) {
                buttonProps.onClick = onClick;
            }
            if (onMouseOut) {
                buttonProps.onMouseOut = onMouseOut;
            }
            if (onMouseOver) {
                buttonProps.onMouseOver = onMouseOver;
            }

            return _react2.default.createElement(
                _Button2.default,
                buttonProps,
                this.props.children
            );
        }
    }]);
    return Button;
}(_react.Component), _class.defaultProps = {
    children: '',
    className: '',
    disabled: false,
    onClick: null,
    onMouseOut: null,
    onMouseOver: null,
    primary: false,
    secondary: false,
    small: false,
    tertiary: false
}, _temp);
exports.default = Button;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.js
// module id = KluA
// module chunks = 46